<template>
    <div>
        <div class="faqs-button-slider">
            <faqs-slider
                @action="selected"
                :categories="categories"
            ></faqs-slider>
        </div>
        <div class="faqs-grid">
            <transition name="fade" tag="span">
                <category-text
                    :list="list"
                    :faqs="faqs"
                    :categories="categories"
                ></category-text>
            </transition>
        </div>
    </div>
</template>
<script>
import FaqsSlider from "./FaqsSlider.vue";
import CategoryText from "./CategoryText";
export default {
    components: { FaqsSlider, CategoryText },
    data() {
        return {
            list: 1
        };
    },
    props: {
        faqs: Array,
        categories: Array
    },
    methods: {
        selected(event) {
            this.list = event;
        }
    }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.faqs-grid {
    margin: 1rem 0;
    @media (min-width: 1024px) {
        margin: 5rem 0;
    }
}
</style>
